import { render, staticRenderFns } from "./BaseDialog.vue?vue&type=template&id=49df19ac&scoped=true"
import script from "./BaseDialog.vue?vue&type=script&lang=ts"
export * from "./BaseDialog.vue?vue&type=script&lang=ts"
import style0 from "./BaseDialog.vue?vue&type=style&index=0&id=49df19ac&prod&lang=scss&scoped=true"
import style1 from "./BaseDialog.vue?vue&type=style&index=1&id=49df19ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49df19ac",
  null
  
)

export default component.exports